import type { RootState } from '@/store/store'

export const selectDigitalReportInfo = (state: RootState) => state.digitalReport
